import {Button, Modal} from 'react-bootstrap';
import React from 'react';
import EntitySelector from './EntitySelector';

class EntitySelectModal extends React.Component {
  render() {
    return (
      <div>
        <Modal
          bsSize="large"
          show={this.props.show}
          backdrop={true}
          onHide={this.props.onHide}
        >
          <Modal.Header closeButton={true}>
            <Modal.Title>Velg et element</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <EntitySelector
              onSelect={this.props.onSelect}
              quickAdd={this.props.quickAdd}
              contentType={this.props.contentType}
              searcher={this.props.searcher}
              searchParams={this.props.searchParams}
              searchFilterFn={this.props.searchFilterFn}
              showArchived={this.props.showArchived}
              searchOnOpen={this.props.searchOnOpen}
              infoDecorator={this.props.infoDecorator}
            />
          </Modal.Body>

          <Modal.Footer>
            {this.props.createUrl &&
              <a
                className="btn btn-default pull-left"
                target="_blank"
                rel="noreferrer"
                onClick={this.props.onHide}
                href={this.props.createUrl}
              >
                Opprett ny (I ny fane)
              </a>
            }
            <Button
              bsStyle="primary"
              onClick={this.props.onHide}
            >
              {this.props.quickAdd ? 'Lukk' : 'Avbryt'}
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

EntitySelectModal.defaultProps = {
  show: true
};

export default EntitySelectModal;
